export const technicianAvailabiltyList = "TECHNICIAN_AVAILABILITY_LIST";
export const timeSlotsList = "TIME_SLOTS_LIST";